import React from 'react';
import { useTranslation } from 'react-i18next';
import { textToDate } from 'utils/common';
import { Box, Typography } from '@p81-common/ui';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';

interface SubscriptionHeaderProps {
  subscriptionExpirationDate: string | null;
}

const SubscriptionHeader = ({
  subscriptionExpirationDate
}: SubscriptionHeaderProps) => {
  const { t } = useTranslation('activity');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        bgcolor: '#F5FAFF',
        borderRadius: 1,
        px: 2,
        py: 1.25,
        mb: 4
      }}
    >
      <AccessTimeRoundedIcon fontSize="small" sx={{ color: '#6B788E' }} />
      <Typography variant="body2" sx={{ color: '#6B788E' }}>
        {t('activity:customers:SUBSCRIPTION_EXPIRATION_DATE')}
      </Typography>
      <Typography variant="body2" sx={{ color: '#42526D' }}>
        {subscriptionExpirationDate
          ? textToDate(subscriptionExpirationDate)
          : '—'}
      </Typography>
    </Box>
  );
};

export default SubscriptionHeader;
